export default "__VITE_ASSET__BNmvlCZG__"